module.exports = __webpack_public_path__ + "img/linkedin.8f5dee70.svg";